import EDC from '../../../shared/globals';
import FlyToScreen from '../animations/fly-to-screen';
import Shake from '../animations/shake';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.MatchOpposites.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);
  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.MatchOpposites.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.question = null;
  this.notes = [];
  this.shakeAnim = null;
};

EDC.Games.MatchOpposites.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.MatchOpposites.Scenes.Main.prototype.constructor = EDC.Games.MatchOpposites.Scenes.Main;

const MatchOpposites = EDC.Games.MatchOpposites.Scenes.Main.prototype;

MatchOpposites.create = function () {
  this.initialize();

  this.createGameUI();
  this.loadIteration();

  const flyToScreen = new FlyToScreen(this, this.notes).start();

  this.createBasicUI();
};

MatchOpposites.createGameUI = function () {
  const container = this.add.container(940, 860);
  container.setSize(690, 325);
  const frame = this.add.sprite(0, 0, 'instructions-frame');
  const instructions = this.add.sprite(0, 0, 'instructions');
  container.add(frame);
  container.add(instructions);
};

MatchOpposites.loadIteration = function () {
  this.createQuestion();
  this.createNotes();
  this.shakeAnim = new Shake(this, this.notes);
  this.shakeAnim.getRandomTime();
};

MatchOpposites.createQuestion = function () {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    align: 'center',
    font: '130px Arial',
    fill: 'white',
    strokeThickness: 10,
  };
  const container = this.add.container(315, 500);
  const note = this.add.sprite(0, 0, 'note-0');
  const text = this.add.text(0, 0, question, font).setOrigin(0.5);
  text.angle = this.gameConfig.assets.notes[0].angleRotation;
  container.add(note);
  container.add(text);
  this.scaleAnimation(container);
  this.question = container;
};

MatchOpposites.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.2,
    scaleY: 1.2,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

MatchOpposites.createNotes = function () {
  const { words } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { answer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    align: 'center',
    font: '130px Arial',
    fill: 'white',
    strokeThickness: 10,
  };
  const positions = {
    0: { x: 1550, y: 165 },
    1: { x: 1650, y: 540 },
    2: { x: 1520, y: 850 },
  };
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const container = this.add.container(positions[i].x, positions[i].y);
    const sprite = this.add.sprite(0, 0, `note-${(i % 3) + 1}`);
    const text = this.add.text(0, 0, words[i], font).setOrigin(0.5);
    text.angle = this.gameConfig.assets.notes[i + 1].angleRotation;
    container.add(sprite);
    container.add(text);
    if (answer === i + 1) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    container.setSize(sprite.displayWidth - 50, sprite.displayHeight);
    container.init_pos_x = container.x;
    container.init_pos_y = container.y;
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    container.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(container);
    this.notes.push(container);
    container.on('pointerdown', this.checkAnswer.bind(this, container), this);
  }
};

MatchOpposites.checkAnswer = function (container) {
  if (container.isCorrect) {
    this.playCorrect();
    container.getData('markAnim').showMark(true, () => {});
    this.notes.map((x) => {
      x.disableInteractive();
      return true;
    });
    this.question.scaleAnim.stop();
    this.question.setScale(1);
    this.time.delayedCall(2000, this.shrinkAnimation, [], this);
  } else {
    this.playWrong();
    container.getData('markAnim').showMark(false, () => {});
    container.first.setTint(0xff0000);
    container.disableInteractive();
  }
};

MatchOpposites.shrinkAnimation = function () {
  this.shakeAnim.stop();
  this.shakeAnim = null;
  this.notes.map((x) => {
    this.tweens.add({
      targets: x,
      scaleX: '+=0.2',
      scaleY: '+=0.2',
      duration: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
    this.tweens.add({
      targets: x,
      scaleX: 0,
      scaleY: 0,
      duration: 500,
      delay: 300,
      ease: 'Sine.easeInOut',
      yoyo: false,
    });
    return true;
  });
  this.tweens.add({
    targets: this.question,
    scaleX: '+=0.2',
    scaleY: '+=0.2',
    duration: 300,
    ease: 'Sine.easeInOut',
    yoyo: false,
  });
  this.tweens.add({
    targets: this.question,
    scaleX: 0,
    scaleY: 0,
    duration: 500,
    delay: 300,
    ease: 'Sine.easeInOut',
    yoyo: false,
    onComplete: this.nextIteration.bind(this),
  });
};

MatchOpposites.nextIteration = function () {
  this.question.destroy();
  this.question = null;
  this.notes.map((container) => {
    container.destroy();
    return true;
  });
  this.notes = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

export default EDC.Games.MatchOpposites.Scenes.Main;
